import { connect } from 'react-redux'
import ReferralList from './components/Referral/ReferralList'

const mapDispatchToProps = dispatch => ({
    dispatch
})

const mapStateToProps = state => ({
  ...state.auth,
  referralList: state.referralList,
})

export default connect(mapStateToProps, mapDispatchToProps)(ReferralList)
